import { APIService } from "services";

export const getMembers = async (pageNo,pageSize,search) => {
    let res;
    if(search.length===0) {
        res = await getAllMembers(pageNo,pageSize);
    }
    else{
        try {
            res = await searchMembers(search,pageNo,pageSize);
        } catch(err) {
             return { records:[], totalCount:0 }
        }
    }
    if(res && res.data){
    return res.data;
    }else{
    return { records:[], totalCount:0 }
    }
    
}


export const addMembers = (data) => {
return APIService.api().post(`/members`,data)
}
export const updateMembers = (data) => {
return APIService.api().post(`/members/update`,data)
}
export const getAllMembers = (pageNo,pageSize) => {
return APIService.api().get(`/members/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const getOneMembers = (member_id) => {
return APIService.api().get(`/members/${member_id}`)
}
export const searchMembers = (searchKey,pageNo,pageSize) => {
return APIService.api().get(`/members/search/${searchKey}/?pageNo=${pageNo}&pageSize=${pageSize}`)
}
export const deleteMembers = (member_id) => {
return APIService.api().post(`/members/updateStatus`)
}
